import type { Components } from 'react-markdown'

import { Link } from '@subaio/components'

import { FintechBridgeReferences } from 'components/FintechBridgeReferences'
import { Heading } from 'components/Heading'
import { GridColumn, GridRow } from 'components/Layout/Grid'
import { Step, StepTimeline } from 'components/Layout/StepTimeline'
import { NavigationCard } from 'components/NavigationCard'
import { SyntaxHighlighter } from 'components/SyntaxHighlighter'

import { Code } from './Code'
import { CodeTabs } from './CodeTabs'
import { Description } from './Description'
import { Table } from './Table'

const baseComponents = {
	h1: (props) => <Heading {...props} level={1} />,
	h2: (props) => <Heading {...props} level={2} />,
	h3: (props) => <Heading {...props} level={3} />,
	h4: (props) => <Heading {...props} level={4} />,
	h5: (props) => <Heading {...props} level={5} />,
	table: (props) => <Table {...props} />,
	code: (props) => <Code {...props} />,
} satisfies Components

export const components = {
	...baseComponents,

	Description,
	Table,
	NavigationCard,
	GridColumn,
	GridRow,
	Link,
	SyntaxHighlighter,
	CodeTabs,
	FintechBridgeReferences,
	StepTimeline,
	Step,
}
